import { Component, OnInit, Input, Inject } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';
import { SafetyInductionService } from '../../../../../app/modules/GET_NEW_UI/services/safety-induction.service';
import { DialogData } from '../../../../../app/modules/inventory/inventory-or-wsre-dialog/inventory-or-wsre-dialog.component';
import { NewInspectionService } from '../../services/new-inspection.service';
import { AdditonalObsNumaricalLimits } from '../../models/create-inspection.model';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-setup-numerical-additionalobs-worn-limit',
  templateUrl: './setup-numerical-additionalobs-worn-limit.component.html',
  styleUrls: ['./setup-numerical-additionalobs-worn-limit.component.scss']
})
export class SetupNumericalAdditionalobsWornLimitComponent implements OnInit {
  QuestionTypeId:number;
  Title:string;  
  NoofDecimal:number;
  worn0Percent:number;
  worn100Percent:number;

  Id:number;

  constructor(
    private _sanitizer: DomSanitizer,
    public dialogRef: MatDialogRef<SetupNumericalAdditionalobsWornLimitComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
    private _inductionService: SafetyInductionService,
    private _inspectionService: NewInspectionService,
  ) { }

  ngOnInit() {

    this.Title = this.data.Title
    this.QuestionTypeId = this.data.QuestionTypeId;

    this.worn0Percent=this.data.worn0Percent;
    this.NoofDecimal=this.data.NoofDecimal;
    this.worn100Percent=this.data.worn100Percent;
    this.Id = this.data.Id;

  }

  onSubmitClick(){
   

    let options = new AdditonalObsNumaricalLimits();
            options.Id =this.Id
            options.Worn0percent = this.worn0Percent;
            options.Worn100percent = this.worn100Percent;
            options.NoOfDecimal =this.NoofDecimal;


console.log("Model", options)
    this._inspectionService.UpdateAdditonalObsNumbericalLimits(options).subscribe(r => {
      if(r){
        this.dialogRef.close(true);
      }else{
        this.dialogRef.close(false);
      }
   });
  }

  onNoClick(){
    this.dialogRef.close(false);
  }

}
